/**
@prop --ux-pagination-button-height: Height of the pagination buttons
@prop --ux-pagination-button-width: Width of the pagination buttons
@prop --ux-pagination-gap-size: Gap size between back/next buttons and page buttons
@prop --ux-pagination-icon-button-width: Width of the back/next buttons
@prop --ux-pagination-more-icon-size: Icon size for the more buttons;
@prop --ux-pagination-input-width: Width of the page input field;
 */
ux-pagination {
  --ux-button-padding-horizontal: 0;
  --ux-button-padding-vertical: 0;
  --ux-button-min-width: var(--ux-pagination-button-width, 60px);
  --ux-button-min-height: var(--ux-pagination-button-height, 40px);
  --ux-icon-button-width: var(--ux-pagination-icon-button-width, 40px);
  --ux-icon-button-height: var(--ux-pagination-button-height, 40px);
  --ux-popover-panel-padding: 8px;
  --ux-input-field-min-width: var(--ux-pagination-input-width);

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: var(--ux-pagination-gap-size, 8px);

  ux-input-field,
  ux-input-field-number {
    width: var(--ux-pagination-input-width);
  }
}

.ux-pagination__inner {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}

.ux-pagination__button-group {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  box-shadow: var(--ux-button-shadow);

  ux-button {
    --ux-button-shadow: none;
  }

  > ux-button:not(:first-of-type) {
    margin-left: -1px;
  }
}

.ux-pagination__page-button {
  width: var(--ux-pagination-button-width);
  height: var(--ux-pagination-button-height);
}

.ux-pagination__ellipsis {
  --ux-button-shadow: none;
  --ux-button-icon-size: var(--ux-pagination-more-icon-size, 24px);
  --ux-button-icon-size-large: var(--ux-pagination-more-icon-size, 24px);
  --ux-button-icon-spacing: 0;

  width: calc(var(--ux-pagination-button-width) - 2px);
  height: var(--ux-pagination-button-height);

  .ux-button__label {
    margin: 0;
    display: none;
  }
}
